import type { ComponentProps } from "react";

import type { QuoteBlockType } from "@features/article-content/model";

import { Body, Heading } from "@shared/ui/typography";

import s from "./quote-with-author.module.scss";

export type QuoteWithAuthorProps = ComponentProps<"div"> & {
  data: QuoteBlockType;
};

export const QuoteWithAuthor = (props: QuoteBlockType) => {
  const { text, authorPosition, author } = props;

  return (
    <div className={s.root}>
      <Heading level={6}>{text}</Heading>
      <div className={s.author}>
        <Body size="caption" weight="semiBold">
          {author}
        </Body>
        <Body size="caption">{authorPosition}</Body>
      </div>
    </div>
  );
};

QuoteWithAuthor.displayName = "QuoteWithAuthor";
